import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css'
import styles from "../../styles/tenant.module.css"
import { useForm } from 'react-hook-form'
import { useMutation } from "@apollo/client";
import { LOAD_TENANTS, DELETE_TENANTS} from "../../graphql/TenantQueries";
import ErrorDisplay from "../common/ErrorDisplay";

function DeleteModal({ setOpenDeleteModal, setOpenActionModal, fieldData }: any) {
    const { register, handleSubmit, formState: { errors } } = useForm({
    })
    const [deleteTenant, { loading: mutationLoading, error: mutationError }] = useMutation(DELETE_TENANTS, {
        refetchQueries: [
          {query: LOAD_TENANTS}, 
          'getTenants' 
        ],
      });


    const data = async () => {
        try {
            const today = new Date(new Date().toISOString());
            await deleteTenant({ variables: { id: fieldData, input: {meta: {deletedOn: today, deleted: true}}}});
            setOpenDeleteModal(false);
            setOpenActionModal(false);
        } catch (error) {
            console.error('Error deleting tenant:', error);
        }
    }


    return (

                <>
                
                <div className={styles["title"]}>
            <h1>Are you sure?</h1>
            <h1>{fieldData}</h1>
        </div><div className={styles["body"]}>
                <form onSubmit={handleSubmit(data)}>
                    <div>
                        <button className={styles["cnclButton"]} onClick={data}>Yes, Delete</button>
                    </div>

                    <div>
                        <button
                            onClick={() => {
                                setOpenDeleteModal(false);
                            } }
                            className={styles["button"]}
                        >
                            No
                        </button>
                    </div>
                </form>
            </div>
            <ErrorDisplay error={mutationError} />
            </>
          
    )
}

export default DeleteModal;